import DOMPurify from 'dompurify';

export const Purify = {
  sanitize(raw: string, tags?: object): string {
    if (DOMPurify.isSupported === false) {
      if (process.env.NODE_ENV === 'production') {
        throw new Error('Sanitize does not work in non DOM environments-- do not run this in production');
      }

      return raw;
    }

    return DOMPurify.sanitize(raw, tags);
  },
};

export default Purify;
